// extracted by mini-css-extract-plugin
module.exports = {"faq":"AutoupdateFAQ_faq__UL6Vd","faq__title":"AutoupdateFAQ_faq__title__E8YL4","faq__items":"AutoupdateFAQ_faq__items__fEBkz"};